/**
 * macOS MDM deployment profiles for the Connect surface.
 *
 * The profiles are ?raw-imported from `agent/mdm/macos/` (the tree the
 * agent team maintains and the MDM runbook documents) so the dashboard
 * never carries a drifting copy.
 *
 * Deploy-freshness note: dashboard deploys trigger on `dashboard/**`
 * only, so an agent-side profile edit reaches customers on the next
 * dashboard deploy, same as any copied asset — but with one source.
 */
import privacyProfile from "../../../agent/mdm/macos/origin-privacy.mobileconfig?raw";

// The static profiles, keyed by their canonical download filename.
export const STATIC_MDM_PROFILES = [
    {
        filename: "origin-privacy.mobileconfig",
        label: "Privacy (FDA)",
        content: privacyProfile,
    },
];

export function downloadTextFile(filename, content, type = "application/x-apple-aspen-config") {
    const blob = new Blob([content], { type });
    const href = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
}
